export default __webpack_public_path__ + "static/SFMono-Medium-4264e9158af16004177ba07cccd40442.woff2";